// @flow

export class LoaderViewModel {}
